export type WorkspaceSyncProgressState = {
  total: number;
  syncing: number;
};

const clampProgress = (value: number) => Math.min(Math.max(value, 0), 1);

export function getWorkspaceSyncRawProgress(
  state: WorkspaceSyncProgressState
): number | undefined {
  if (!Number.isFinite(state.total) || state.total <= 0) {
    return undefined;
  }

  const syncing = Number.isFinite(state.syncing)
    ? Math.min(Math.max(state.syncing, 0), state.total)
    : 0;

  return clampProgress((state.total - syncing) / state.total);
}

export function getWorkspaceSyncDisplayProgress(
  previousProgress: number | undefined,
  rawProgress: number | undefined,
  syncing: boolean
): number | undefined {
  if (!syncing) {
    return undefined;
  }

  if (rawProgress === undefined) {
    return previousProgress;
  }

  return previousProgress === undefined
    ? rawProgress
    : Math.max(previousProgress, rawProgress);
}
